import Service from "../../services";

const Auth = {
    namespaced: true,
    state: {
        user: null,
        role: null,
        sideMenus: [],
        accessToken: null,
        refreshToken: null,
        workState: null,
        permission: null
    },
    mutations: {
        SET_ACCESS_TOKEN: (state, token) => {
            state.accessToken = token
        },
        SET_REFRESH_TOKEN: (state, token) => {
            state.refreshToken = token
        },
        SET_USER: (state, user) => {
            state.user = user
        },
        SET_ROLE: (state, role) => {
            state.role = role
        },
        SET_SIDEMENU: (state, data) => {
            state.sideMenu = data
        },
        SET_WORK_STATE: (state, data) => {
            state.workState = data
        },
        SET_PERMISSION: (state, data) => {
            state.permission = data
        }
    },
    actions: {
        register({
            commit
        }, data) {
            return Service.Auth.register(data)
                .then(res => {
                    if (!res.data.success) {
                        //return Promise.reject('Invalid username/password')
                    }
                    return res.data
                })
                .then(data => {
                    //commit('SET_ACCESS_TOKEN', data.data.access_token)
                    //commit('SET_REFRESH_TOKEN', data.data.refresh_token)
                    return data
                })
        },
        login({
            commit
        }, data) {
            return Service.Auth.login(data)
                .then(res => {
                    if (!res.data.success) {
                        return Promise.reject('Invalid username/password')
                    }
                    return res.data
                })
                .then(data => {
                    commit('SET_ACCESS_TOKEN', data.data.access_token)
                    commit('SET_REFRESH_TOKEN', data.data.refresh_token)
                    return data
                })
        },
        setUser({
            commit
        }) {
            return Service.Auth.getUser()
                .then(data => {
                    commit('SET_USER', data.data)
                    //commit('SET_PERMISSION', data.data.user.permission)
                    return data.data;
                })
                .catch(err => Promise.reject(err))
        },
        setWorkState({
            commit
        }, data) {
            commit('SET_WORK_STATE', data)
        },
        logout({
            commit
        }) {
            commit('SET_USER', null)
            commit('SET_ACCESS_TOKEN', null)
            commit('SET_PERMISSION', null)
            commit('SET_REFRESH_TOKEN', null)
        }
    },
}

export default Auth